/**
 * 批量导入日志弹层
 * 对应原 Vue 项目 BatchPhoneLogs.vue
 *
 * 硬编码 queryId（必须保持一致）：
 *   - 导入日志：7a8b3748-18ec-4d89-952d-a7a695aa73fa
 */
import React, { useState, useEffect } from "react";
import { Modal, Table, message } from "antd";
import commonService from "@/service/common";

// 导入日志查询 ID（硬编码，与原项目保持一致）
const QUERY_ID_LOGS = "7a8b3748-18ec-4d89-952d-a7a695aa73fa";

const BatchPhoneLogsModal = ({ visible, qrData, record, onClose }) => {
  const [columns, setColumns] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      getIqueryColumns();
      getIqueryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  /**
   * 查询导入日志列定义
   */
  const getIqueryColumns = async () => {
    const params = {
      queryId: QUERY_ID_LOGS,
      cluster: "default",
      usePaging: false,
    };
    try {
      const res = await commonService.IqueryColumn(params);
      if (res && res.success && res.content) {
        const cols = (res.content.columns || res.content || []).map((item) => ({
          ...item,
          dataIndex: item.name,
          key: item.name,
          align: item.alignContent || "left",
        }));
        setColumns(cols);
      }
    } catch (error) {
      console.error("查询导入日志列定义失败:", error);
    }
  };

  /**
   * 查询导入日志数据
   */
  const getIqueryData = async () => {
    setLoading(true);
    const codeParams = qrData?.codeParams;
    const params = {
      queryId: QUERY_ID_LOGS,
      cluster: "default",
      usePaging: false,
      parameters: {
        _miceId: codeParams?.data?.eventData?.processId || record?.miceId,
        _categoryType: codeParams?.itemType || 1,
        _itemId: codeParams?.data?.orderDetail?.itemId || record?.supplierId,
        _supplierId:
          codeParams?.data?.orderDetail?.itemId || record?.supplierId,
      },
    };
    try {
      const res = await commonService.IqueryData(params);
      if (res && res.success) {
        const rows = res.content?.rows || res.content || [];
        setDataList(rows.map((row, idx) => ({ ...row, key: idx })));
      }
    } catch (error) {
      console.error("查询导入日志数据失败:", error);
      message.error("查询导入日志失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="批量导入日志"
      visible={visible}
      width={800}
      destroyOnClose
      footer={null}
      onCancel={onClose}
    >
      <Table
        columns={columns}
        dataSource={dataList}
        loading={loading}
        rowKey="key"
        size="small"
        scroll={{ y: 400 }}
        pagination={{ pageSize: 10, showTotal: (total) => `共 ${total} 条` }}
      />
    </Modal>
  );
};

export default BatchPhoneLogsModal;
